"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _net = require("libs/utils/net");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } // handles everything related to the logged user.
// logout does a full refresh, as well as navigation to an event,
// so it assumes that once the user is initialized, it does not have to be changed
// user init is exposed through a promise that resolve when the user is loaded, or after successful login
var UserService = /* @ngInject */function UserService(USER_SESSION_ENDPOINT, $rootScope, $q, $http, $injector, $window, accountService) {
  // initial state promise. will resolve on login or initial session check
  var initState = $q.defer();
  var currentEventId = null;
  var getSession = function getSession() {
    return window.BSTG.services.user.getSession();
  };
  var orgIsSuspended = function orgIsSuspended(org) {
    return org.bs_is_blocked === true;
  };
  // if all organization are suspended, the user is in and at least one organization is locked,
  // the backstage is getting locked.
  var isUserAccountSuspended = function isUserAccountSuspended(user) {
    var suspendedOrgsUserIsIn = user.orgs.filter(orgIsSuspended).length;
    var allOrgsUserIsInAreSuspended = suspendedOrgsUserIsIn === user.orgs.length;
    return suspendedOrgsUserIsIn > 0 && allOrgsUserIsInAreSuspended;
  };

  // called after a login or a proper session retriaval to build the user
  // and notify other services depending on the user init state
  var tryFinalizeInit = function tryFinalizeInit() {
    getSession().then(function (_ref) {
      var session = _ref.data;
      // some backward compatibility?
      if (session && session.userCtx) {
        session = session.userCtx;
      }
      if (!session || session.authenticated !== true) {
        throw new Error('invalid session');
      }
      var userAllowedPaths = _.compact(session.bstg_allowed_paths);
      if (session.from_accredited_link && userAllowedPaths && userAllowedPaths.length) {
        $rootScope.userAllowedPaths = session.bstg_allowed_paths;
      }

      // retrieve user and augment it with changes
      return accountService.getUser(session.name, {
        noEvents: true
      }).then(function (_ref2) {
        var userInfo = _ref2.data;
        // we now store a list of the user's most recent changes in the session
        userInfo.changes = session.changes;
        // accreditated links have no names
        if (session.from_accredited_link) {
          userInfo.name = session.name;
        }
        // set the user on our rootScope and resolve the promise
        $rootScope.user = userInfo;
        $rootScope.initUser = true;
        initState.resolve($rootScope.user);
        var isAccountSuspended = isUserAccountSuspended(userInfo);
        if (isAccountSuspended) {
          $rootScope.isAccountSuspended = isAccountSuspended;
        }
        return $rootScope.user;
      });
    }).catch(function (error) {
      $rootScope.initUser = true;
      console.error('Could not initialize user', error.message);
      return initState.reject(error);
    });
    return initState.promise;
  };
  var userService = {
    /**
     * Will try to init the user of not already done.
     * Returns a promise which resolves only when the user is ready.
     * @param {String} eventId
     * @return {Promise}
     */
    init: function init(eventId) {
      if (!currentEventId) {
        currentEventId = eventId;
        tryFinalizeInit();
      }
      return initState.promise;
    },
    /**
     * Check if session is still valid
     * @return {Promise}
     */
    checkSession: function checkSession() {
      return getSession().then(function () {
        return true;
      });
    },
    /**
     * Retrieve the current logged user
     * @return {Object}
     */
    getCurrentUser: function getCurrentUser() {
      return $rootScope.user;
    },
    /**
     * Get current user organizations
     * @return {Promise}
     */
    getCurrentUserOrgs: function getCurrentUserOrgs() {
      var user = userService.getCurrentUser();
      if (!user || user.fp_type === 'accredited_link') {
        return $q.resolve([]);
      }
      return accountService.getUserOrgs(user.name).then(function (_ref3) {
        var data = _ref3.data;
        return data;
      });
    },
    /**
     * Get current user events
     * @return {Promise}
     */
    getUserEvents: function getUserEvents() {
      var user = userService.getCurrentUser();
      if (!user) {
        return $q.resolve([]);
      }
      // shortcut. If the user has no events it will be calling for events anyway.
      if (user.events && user.events.length) {
        return $q.resolve(user.events);
      }
      return accountService.getUser(user.name).then(function (_ref4) {
        var userInfo = _ref4.data;
        var events = $injector.get('eventService').getEventInstancesForUser(userInfo);
        user.events = events;
        return events;
      });
    },
    /**
     * Attempt to log the user with given username/password
     *
     * @param {String} username
     * @param {String} password
     * @param {Object} [accepted_clauses] the user's accepted usage clauses
     *
     * @return {Promise}
     */
    login: function login(username, password, accepted_clauses) {
      var credentials = {};

      // determine the event context we're currently in
      if (currentEventId) {
        // we'll supply it for the session creation routine to consume
        credentials.eid = currentEventId;
      }
      _.extend(credentials, {
        name: username,
        password: password,
        accepted_clauses: accepted_clauses
      });
      return $http.post(USER_SESSION_ENDPOINT, credentials, {
        isSessionCall: true
      }).then(function (_ref5) {
        var data = _ref5.data;
        if (data.warning) {
          $rootScope.setFlashMessage(data.warning, 'warning');
        }
        return tryFinalizeInit();
      });
    },
    /**
     * Logout current user. Will do a full reload if successful
     */
    logout: function logout() {
      return window.BSTG.services.user.logout();
    },
    // PERMISSIONS
    /**
     * Check if current user matches one of the provided conditions (OR), which can be one of those.
     * Several conditions can be put into one to match several conditions at the same time.
     * No condition will return true
     *
     * { userId: id } matches if userId is id
     * { isSpotme: true} matches if user belongs to spotme org
     * { globalRole: role }
     * { eventRole: role, [eventId: eid] } eventId is optional, if not provided, current event is used
     * { eventId: eid } has any role in given event
     * { orgRole: role, orgId: orgId }
     * { orgId: orgId } has any role in given organisation
     *
     * @param {Object} roles
     * @returns {Boolean}
     */
    matchesRoles: function matchesRoles() {
      var _window$BSTG$services;
      // forward to vanilla service
      return (_window$BSTG$services = window.BSTG.services.user).matchesRoles.apply(_window$BSTG$services, arguments);
    },
    /**
     * Determine if the current user has a permission given a context
     * @param  {string}  permissionName name of the permission for which we want to know if the user has access
     * @param  {Object}  context context determining if the user has permission
     * @param  {string}  [context.event_id] context attribute event_id if in the context of an event
     * @param  {string}  [context.org_id] context attribute org_id if in the context of an org
     * @return {Boolean} true if the user has a role enabling the permission and the role is either a global role or
     * every attribute required for the role are both present in the attributed role and the context and are all equal
     * false otherwise
     */
    hasPermission: function hasPermission(permission, context) {
      // forward to vanilla service
      return window.BSTG.services.user.hasPermission(permission, context);
    },
    /**
     * Determine if the current user can attribute assign a different role
     * @param  {Object}  userRoles the supported user roles
     * @param  {Object}  requiredRole the required role
     * @param  {string}  [requiredRole.role] name of the role
     * @param  {string}  [requiredRole.event_id] context attribute event_id if in the context of an event
     * @param  {string}  [requiredRole.org_id] context attribute org_id if in the context of an org
     * @return {Boolean} true if the user has a role enabling the permission and the role is either a global role or
     * every attribute required for the role are both present in the attributed role and the context and are all equal
     * false otherwise
     */
    canAssignRole: function canAssignRole(userRoles, requiredRole) {
      // forward to vanilla service
      return window.BSTG.services.user.canAssignRole(userRoles, requiredRole);
    },
    /**
     * Return full path for users profile in given event
     * @param {String} eventNodeUrl cloud node url
     * @param {String} eventId event ID
     * @param {String} userId user ID
     * @param {Boolean} [isContentHub=false]
     * @returns {String} user'sprofile url
     */
    getProfileUrl: function getProfileUrl(eventNodeUrl, eventId, userId) {
      var isContentHub = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return window.BSTG.services.user.getProfileUrl(eventNodeUrl, eventId, userId, isContentHub);
    },
    /**
     * Checks if the current user can read the organization document
     *
     * @param {String} org_id the organization id
     *
     * @returns {Boolean} if user can read the organization doc
     */
    canReadOrgDoc: function canReadOrgDoc(org_id) {
      return window.BSTG.services.user.canReadOrgDoc(org_id);
    },
    /**
     * Check if a feature is enabled for organisation
     *
     * @param {string} flag the name of the feature to check
     */
    getOrgsByFeatureFlag: function getOrgsByFeatureFlag(flag) {
      return window.BSTG.services.user.getOrgsByFeatureFlag(flag);
    },
    /**
     * Is user event speaker?
     *
     * @param {String} eventId event ID
     * @param {Object} [user=this.user] user object or current user if not provided
     * @returns {Boolean}
     */
    isEventSpeaker: function isEventSpeaker(eventId) {
      var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.user;
      return window.BSTG.services.user.isEventSpeaker(eventId, user);
    },
    /**
     * Is user event moderator?
     *
     * @param {String} eventId event ID
     * @param {Object} [user=this.user] user object or current user if not provided
     * @returns {Boolean}
     */
    isEventModerator: function isEventModerator(eventId) {
      var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.user;
      return window.BSTG.services.user.isEventModerator(eventId, user);
    },
    /**
     * Check if user was invited by link to the event
     *
     * @param {Object} event event object
     * @returns {Boolean}
     */
    isInvitedByLink: function isInvitedByLink(event) {
      return window.BSTG.services.user.isInvitedByLink(event);
    },
    /**
     * Is user a Beta tester
     * @returns {Boolean}
     */
    isBetaTester: function isBetaTester() {
      return window.BSTG.services.user.isBetaTester();
    },
    /**
     * Is user a super admin
     * @returns {Boolean}
     */
    isSuperAdmin: function isSuperAdmin() {
      return window.BSTG.services.user.isSuperAdmin();
    },
    /**
     * Gets the webapp url for bstg user
     *
     * @param {String} event_id the event id
     * @param {String} redirect the redirect url
     *
     * @returns {String} url
     */
    getWebappLoginUrl: function getWebappLoginUrl(event_id, redirect) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return window.BSTG.services.user.getWebappLoginUrl(event_id, redirect);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /**
     * Filter array of items by matching the user roles
     * Array items not defining `roles` property will stay in the result array.
     *
     * @param {Array<Object>} items
     *
     * @returns {Array} items filtered according to roles of current user
     */
    filterByRoles: function filterByRoles(items) {
      return window.BSTG.services.user.filterByRoles(items);
    }
  };
  return userService;
};
UserService.$inject = ["USER_SESSION_ENDPOINT", "$rootScope", "$q", "$http", "$injector", "$window", "accountService"];
UserService.$inject = ["USER_SESSION_ENDPOINT", "$rootScope", "$q", "$http", "$injector", "$window", "accountService"];
angular.module('backstage.services').factory('userService', UserService)
// backward compatibility
.factory('authHelper', UserService)
// add http interceptor if a 401 is catched
.config(/* @ngInject */["$httpProvider", function ($httpProvider) {
  var interceptor = function interceptor() {
    return {
      responseError: function responseError(response) {
        return (0, _net.requestErrorInterceptor)(response);
      }
    };
  };
  $httpProvider.interceptors.push(interceptor);
}]);